<template>
  <div class="min-h-screen bg-gray-50 py-12">
    <div class="container mx-auto px-4">
      <div class="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 class="text-3xl font-bold text-center mb-2 text-gray-800">
          Teste de Formulário Dinâmico
        </h1>
        <p class="text-center text-gray-600 mb-8">
          Para testar, altere o slug abaixo para o slug do seu formulário
        </p>

        <!-- Input para slug do formulário -->
        <div v-if="!formSlug" class="mb-8">
          <label for="slug-input" class="block text-sm font-medium text-gray-700 mb-2">
            Digite o slug do formulário:
          </label>
          <div class="flex gap-2">
            <input
              id="slug-input"
              v-model="tempSlug"
              type="text"
              placeholder="ex: inscricao-evento"
              class="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              @keyup.enter="loadForm"
            />
            <button
              @click="loadForm"
              class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Carregar
            </button>
          </div>
          <p class="mt-2 text-sm text-gray-500">
            Pressione Enter ou clique em Carregar para começar
          </p>
        </div>

        <!-- Botão para trocar formulário -->
        <div v-else class="mb-4 flex justify-between items-center">
          <p class="text-sm text-gray-600">
            Formulário: <span class="font-semibold">{{ formSlug }}</span>
          </p>
          <button
            @click="resetForm"
            class="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Trocar formulário
          </button>
        </div>

        <!-- Componente do Formulário Dinâmico -->
        <DynamicForm
          v-if="formSlug"
          :key="formSlug"
          :slug="formSlug"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import DynamicForm from '@/components/dynamic-form/DynamicForm.vue';

export default {
  name: 'TestForm',
  components: {
    DynamicForm
  },
  setup() {
    const tempSlug = ref('');
    const formSlug = ref('');

    const loadForm = () => {
      if (tempSlug.value.trim()) {
        formSlug.value = tempSlug.value.trim();
      }
    };

    const resetForm = () => {
      formSlug.value = '';
      tempSlug.value = '';
    };

    return {
      tempSlug,
      formSlug,
      loadForm,
      resetForm
    };
  }
};
</script>

<style scoped>
/* Tailwind CSS já está configurado no projeto */
</style>
